import Store from '@/store';
import PTC_Notas from '@/api/PTC/PTC_Notas.client';
import Notifier from '@/libs/Notifier';

export default class PTC_NotasService {
  constructor() {
    this.client = new PTC_Notas();
    this.store = Store;
    this.notify = new Notifier();
  }

  async retornaNotas(query) {
    try {
      this.store.commit('PTC_NotasClient/SET_IS_LOADING', true);
      // Never leave another order's invoices visible if this lookup fails.
      this.store.commit('PTC_NotasClient/SET_NOTAS', []);
      const data = await this.client.retornaNotas(query);
      this.store.commit('PTC_NotasClient/SET_NOTAS', data.notas);
      this.store.commit('PTC_NotasClient/SET_SELECT', data.select);
    } catch (error) {
      throw this.notify.error(error.message);
    } finally {
      this.store.commit('PTC_NotasClient/SET_IS_LOADING', false);
    }
  }

  async retornaDanf(query) {
    try {
      const data = await this.client.retornaDanf(query);
      return data;
    } catch (error) {
      throw this.notify.error(error.message);
    }
  }

  async retornaXmlNota(query) {
    try {
      const data = await this.client.retornaXmlNota(query);
      return data;
    } catch (error) {
      throw this.notify.error(error.message);
    }
  }
}
